/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ChangeSelectedPermissionsHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { FeedPermission } from "Feed/Common/Contracts/Feed";

export class ChangeSelectedPermissionsHandler {
    public static handle(state: IFeedSettingsState, permissions: FeedPermission[]): void {
        state.selectedPermissions = permissions;
    }
}
